'use client';

import { WarningModal, ButtonBase } from '../../../common';
import { useModalDrawerContext } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { FilledDismiss } from '../../../common/svgIcons';

const CancelTradeWithConfirmButton = ({
  translations,
}: {
  translations: {
    areYouSureTradeCancel: string;
    noDontCancel: string;
    yesGoToPortfolio: string;
  };
}) => {
  const { showModal } = useModalDrawerContext();

  const showConfirmationModal = () => {
    showModal(WarningModal, {
      title: translations.areYouSureTradeCancel,
      cancelBtnText: translations.noDontCancel,
      continueLink: {
        text: translations.yesGoToPortfolio,
        url: '/portfolio',
      },
    });
  };

  return (
    <ButtonBase
      onClick={showConfirmationModal}
      visual="ghost"
      size="small"
      aria-label="cancel trade"
    >
      <FilledDismiss size={24} />
    </ButtonBase>
  );
};

export { CancelTradeWithConfirmButton };
